/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { faq, getFaqDestacados } from "../store/modules/FaqStore";
import { user } from "../store/modules/UserStore";
import { request } from "../store/modules/RequestStore";

import { useGlobalContext } from "../context";

import { ViewRequests } from "../components/svg/ViewRequests";
import { CreateRequest } from "../components/svg/CreateRequest";
import { LibreriaSolicitudes } from "../components/svg/LibreriaSolicitudes";

import {
  ArticlesTitleLink,
  CustomLink,
  Destacados,
  HomeSearch,
} from "../components/HomePage/HomeElements";
import Article from "../components/svg/Article";
import { LupaBuscar } from "../components/svg/LupaBuscar";
import {
  getUsers,
  setAutofillRequestData,
  getSelfServiceConfiguration,
} from "../store/modules/RequestStore";

import marketplaceIcon from "../assets/icons/marketplace-icon.svg";

import Footer from "../components/layout/Footer";
import { AiOutlineReload } from "react-icons/ai";
import { IconContext } from "react-icons/lib";
import { useTranslation } from "react-i18next";
import TranslatableText from "../components/Multilanguage/TranslatableText";

const IndexPage = () => {
  const dispatch = useDispatch();
  const [isLoading, setisLoading] = useState(true);
  const faqList = useSelector(faq);
  const userDetailts = useSelector(user);
  const configurationSelf = useSelector(request);

  const [redirect, setRedirect] = useState("");

  const { secundaryColor, color7 } = useGlobalContext();

  const { t } = useTranslation();

  const search = (e: any) => {
    e.preventDefault();
    setRedirect(e.target.search.value);
  };

  useEffect(() => {
    dispatch(setAutofillRequestData());
    dispatch(getSelfServiceConfiguration(setisLoading));
    dispatch(getUsers(userDetailts.CompanyID));
    setTimeout(() => {
      dispatch(getFaqDestacados());
    }, 2000);
  }, []);

  return (
    <div>
      {redirect !== "" ? (
        <Redirect
          to={{ pathname: "/faq/all", search: `?search=${redirect}` }}
        />
      ) : (
        <></>
      )}
      {isLoading === true ? (
        <p className="h-screen flex justify-center">
          {t("createRequest.loading")}...
          <IconContext.Provider
            value={{
              color: "#868a91",
              className: "animate-spin h-6 w-6 ",
            }}
          >
            <AiOutlineReload />
          </IconContext.Provider>
        </p>
      ) : (
        <>
          <div className="flex">
            <div className="container mx-auto">
              <div className="w-full pb-2 my-6 flex justify-end">
                <form
                  onSubmit={(e) => search(e)}
                  className="lg:w-1/3 md:w-4/6 sm:w-full relative"
                >
                  <HomeSearch
                    type="search"
                    name="search"
                    placeholder={t("main.inputSearch")}
                    className="bg-inherit h-10 px-5 pr-10 rounded-full text-sm focus:outline-none w-full"
                  />
                  <button type="submit" className="absolute right-4 top-3">
                    <LupaBuscar />
                    {""}
                  </button>
                </form>
              </div>
              <div className="my-12 flex flex-col items-center md:grid md:grid-cols-4 gap-8 justify-center text-md ml-1">
                <CustomLink
                  bg={secundaryColor}
                  to="/request/all"
                  className={`w-full flex flex-col items-center shadow-button justify-center text-center cursor-pointer w-1/3 h-56 px-8 border rounded-lg ml-5`}
                >
                  <div className="mb-5">
                    <ViewRequests />
                  </div>
                  <h1 className={`font-bold text-${color7}`}>
                    {t("main.myApplications.title")}
                  </h1>
                  <p className="text-black">{t("main.myApplications.desc")}</p>
                </CustomLink>
                {configurationSelf.selfServiceConfiguration
                  .activateNewRequest === true && (
                  <CustomLink
                    bg={secundaryColor}
                    to="/request/new"
                    className={`w-full flex flex-col items-center justify-center shadow-button text-center cursor-pointer w-1/3 h-56 px-8 border rounded-lg ml-5`}
                  >
                    <div className="mb-5">
                      <CreateRequest size={`75px`} />
                    </div>
                    <h1 className={`font-bold text-${color7}`}>
                      {t("main.createNewApplication.title")}
                    </h1>
                    <p className="text-black" style={{ marginBottom: "20px" }}>
                      {t("main.createNewApplication.desc")}
                    </p>
                  </CustomLink>
                )}
                <CustomLink
                  bg={secundaryColor}
                  to="/faq/all"
                  className={`w-full flex flex-col items-center justify-center shadow-button text-center cursor-pointer w-1/3 h-56 px-8 border rounded-lg ml-5`}
                >
                  <div className="mb-5">
                    <LibreriaSolicitudes />
                  </div>
                  <h1 className={`font-bold text-${color7}`}>
                    {t("main.solutionLibrary.title")}
                  </h1>
                  <p className="text-black">{t("main.solutionLibrary.desc")}</p>
                </CustomLink>
                {configurationSelf.selfServiceConfiguration
                  .activateMarketPlace === true && (
                  <CustomLink
                    bg={secundaryColor}
                    to="/MarketPlace/index"
                    className={`w-full flex flex-col items-center justify-around shadow-button text-center cursor-pointer w-1/3 h-56 px-8 border  rounded-lg ml-5`}
                  >
                    <div className="">
                      <img
                        src={`${marketplaceIcon}`}
                        style={{ height: "132px", marginRight: "15px" }}
                        alt=""
                      />
                    </div>
                    <h1 className={`font-bold text-${color7}`}>
                      {t("main.marketPlace.title")}
                    </h1>
                    <p className="text-black mb-12">
                      {t("main.marketPlace.desc")}
                    </p>
                  </CustomLink>
                )}
              </div>
              <div className="w-full flex flex-col">
                <div className="flex justify-between">
                  <ArticlesTitleLink to="/faq/all">
                    {t("main.featureArticles")}
                  </ArticlesTitleLink>
                </div>
                <div className="flex flex-col text-gray-500 font-medium">
                  {faqList.faqDestacados.map((faq) => {
                    return (
                      <Destacados to={`/faq/${faq.faqID}`} key={faq.faqID}>
                        <span>
                          <Article />
                        </span>
                        <TranslatableText text={faq.question} />
                      </Destacados>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <Footer />
    </div>
  );
};

export default IndexPage;
